// extracted by mini-css-extract-plugin
export default {"content":"HtmlContent_content__f1IFR"};